import React, { useState, useEffect, useRef } from 'react';

const Partners = ({ data, id }) => {
    // 显示数量固定为5
    const visibleCount = 5;
    const imgWidth = 200; // 单个图片宽度
    const gap = 48; // space-x-6 对应的间距 6*4=24px
    const totalItemWidth = imgWidth + gap;

    // 分3行数组
    const row1 = data.items.filter((_, i) => i % 3 === 0);
    const row2 = data.items.filter((_, i) => i % 3 === 1);
    const row3 = data.items.filter((_, i) => i % 3 === 2);

    // 无限滚动的长度
    const length1 = row1.length * totalItemWidth;
    const length2 = row2.length * totalItemWidth;
    const length3 = row3.length * totalItemWidth;

    // 状态保存每行的位移（单位：px）
    const [offset1, setOffset1] = useState(0);
    const [offset2, setOffset2] = useState(-length2);
    const [offset3, setOffset3] = useState(0);

    // refs用于控制动画和计时器
    const speed = 1; // 每帧移动1px，速度可调，越小越慢
    const requestRef1 = useRef();
    const requestRef2 = useRef();
    const requestRef3 = useRef();

    // 动画函数 行1：左->右滚动（offset递增）
    const animate1 = () => {
        setOffset1(prev => {
            const resetPoint = row1.length * totalItemWidth;
            let next = prev + speed;
            if (next >= resetPoint) {
                return 0; // 无缝跳转到开头
            }
            return next;
        });
        requestRef1.current = requestAnimationFrame(animate1);
    };

    // 行2：右->左滚动（offset递减）
    const animate2 = () => {
        setOffset2(prev => {
            const resetPoint = 0;             // 停止点为0
            const startPoint = -length2;      // 起始点为负总长度
            let next = prev + speed;          // 递增offset2（负数逐渐变大）
            if (next >= resetPoint) {         // 到达0时重置到起始点，形成循环
                return startPoint;
            }
            return next;
        });
        requestRef2.current = requestAnimationFrame(animate2);
    };

    // 行3：左->右滚动
    const animate3 = () => {
        setOffset3(prev => {
            const resetPoint = row3.length * totalItemWidth;
            let next = prev + speed;
            if (next >= resetPoint) {
                return 0;
            }
            return next;
        });
        requestRef3.current = requestAnimationFrame(animate3);
    };

    useEffect(() => {
        requestRef1.current = requestAnimationFrame(animate1);
        requestRef2.current = requestAnimationFrame(animate2);
        requestRef3.current = requestAnimationFrame(animate3);

        return () => {
            cancelAnimationFrame(requestRef1.current);
            cancelAnimationFrame(requestRef2.current);
            cancelAnimationFrame(requestRef3.current);
        };
    }, [length1, length2, length3]);

    const imgWrapperCls = "border border-gray-400 rounded-md p-1 flex-shrink-0";

    // 为了实现无缝滚动，需要把数组复制一次，拼接到后面，实现循环效果
    function renderRow(row, offset, reverse = false) {
        // 拼接数组
        const doubleRow = [...row, ...row];

        // transform计算
        const transformStyle = reverse
            ? `translateX(${offset}px)`  // 右->左移动 offset 是负值
            : `translateX(${-offset}px)`; // 左->右移动 offset 递增，画面往左移

        return (
            <div className="overflow-hidden w-full" style={{ willChange: 'transform' }}>
                <div
                    className="flex space-x-12"
                    style={{
                        transform: transformStyle,
                        transition: 'transform 0.1s linear',
                        width: doubleRow.length * totalItemWidth,
                    }}
                >
                    {doubleRow.map((item, idx) => (
                        <div key={idx} className={imgWrapperCls} style={{ width: imgWidth }}>
                            <img src={item.img} alt="" style={{ width: '100%' }} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <section id={id} className="py-4 mt-10 lg:mt-20 xl:mt-24">
            <div className="w-full px-4 lg:w-[70%] lg:max-w-[1440px] mx-auto md:text-center">

                <div className="max-w-5xl space-y-3 md:mx-auto">
                    <h3 className="text-gray-800 font-semibold text-3xl sm:text-4xl xl:text-4xl">
                        {data.title}
                    </h3>
                    <p className="text-gray-800 mt-3 text-sm sm:text-base">
                        {data.subtitle}
                    </p>
                </div>

                <div className="mx-auto lg:w-[70%] lg:max-w-[1440px] space-y-8 mt-6 sm:mt-8 lg:mt-16 xl:mt-20">
                    {/* 行1：左->右滚 */}
                    {renderRow(row1, offset1, false)}

                    {/* 行2：右->左滚 */}
                    {renderRow(row2, offset2, true)}

                    {/* 行3：左->右滚 */}
                    {renderRow(row3, offset3, false)}
                </div>

                {/* 蓝底白字按钮（带圆角和箭头） */}
                <div className="mt-6 sm:mt-8 lg:mt-16 xl:mt-20 flex justify-center">
                    <a
                        href={"/partner"}
                        className="inline-flex items-center px-8 py-4 bg-blue-500 text-white text-lg font-medium rounded-full hover:bg-blue-600 transition"
                    >
                        {data.buttonName}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 ml-4">
                            <path fillRule="evenodd" d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z" clipRule="evenodd" />
                        </svg>
                    </a>
                </div>

            </div>
        </section>
    );
};

export default Partners;
